<template>
  <div class="map-container">
    <div class="select-container">
      <v-select
          style="width: 200px"
          v-model="selectedCoordinates"
          dense
          hide-details
          solo
          :items="cities"
          item-text="name"
          item-value="value"
      />
    </div>
    <yandex-map
        :coords="[this.selectedCoordinates.lat, this.selectedCoordinates.lon]"
        zoom="10"
        style="width: 100%; height: 100%"
        :behaviors="['default']"
        :controls="['typeSelector','geolocationControl','zoomControl']"
        @boundschange="updateBounds($event)"
    >
      <template v-for="point in points">
        <ymap-marker
            marker-type="placemark"
            :icon='point.style'
            :marker-id=point.id
            :coords=point.coords
            :hint-content="`<span>${point.name}</span><br>${point.hint}`"
            @click="clickOnPoint(point)">
        </ymap-marker>
      </template>
    </yandex-map>
    <div v-if="showMapLegend" class="legend-container">
      <map-legend/>
    </div>
    <div v-else class="small-legend-container">
      <v-btn small @click="showMapLegend = !showMapLegend">Показать легенду</v-btn>
    </div>
    <div v-if="err" class="alert-container">
      <v-alert
          dense
          outlined
          type="error"
      >
        Ошибка при загрузке АПН
      </v-alert>
    </div>
  </div>
</template>


<script>
import { bus } from "@/main"
import axios from "axios";
import {yandexMap, ymapMarker} from 'vue-yandex-maps'
import MapLegend from "@/components/MapLegend.vue";
export default {
  components: {
    "map-legend": MapLegend,
    'yandex-map': yandexMap,
    'ymap-marker': ymapMarker
  },
  data: () => ({
    selectedCoordinates: {
      lat: 56.0184,
      lon: 92.8672,
    },
    points: [],
    usePointId: 0,
    firstLaunch: true,
    loading: false,
    isWait: false,
    err: false,
    intervalId: 0,
    showMapLegend: false,
    cities: [
      {
        name: "Красноярск",
        value: {
          lat: 56.0184,
          lon: 92.8672,
        }
      },
      {
        name: "Ачинск",
        value: {
          lat: 56.27,
          lon: 90.5,
        }
      },
      {
        name: "Зеленогорск",
        value: {
          lat: 56.11,
          lon: 94.6,
        }
      },
      {
        name: "Канск",
        value: {
          lat: 56.2,
          lon: 95.72,
        }
      },
      {
        name: "Сосновоборск",
        value: {
          lat: 56.12,
          lon: 93.34,
        }
      },
      {
        name: "Минусинск",
        value: {
          lat: 53.71,
          lon: 91.69,
        }
      },
      {
        name: "Лесосибирск",
        value: {
          lat: 58.24,
          lon: 92.48,
        }
      },
      {
        name: "Назарово",
        value: {
          lat: 56.01,
          lon: 90.4,
        }
      },
    ]
  }),
  methods: {
    updateBounds(e) {
      this.selectedCoordinates.lat = e.originalEvent.newCenter[0];
      this.selectedCoordinates.lon = e.originalEvent.newCenter[1];
    },
    clickOnPoint(point) {
      if (this.usePointId === point.id || this.loading) {
        return;
      }

      if (!point.isFactory) {
        this.selectedCoordinates.lat = point.coords[0]
        this.selectedCoordinates.lon = point.coords[1]
        this.usePointId = point.id

        bus.$emit('load-sensors', point)

      } else if (point.isFactory) {
        this.usePointId = 0
        this.selectedCoordinates.lat = point.coords[0]
        this.selectedCoordinates.lon = point.coords[1]

        bus.$emit('load-factory', point)
      }
    },
    setImageStyle(element, imageFile) {
      return {
        layout: 'default#image',
        imageHref: require(`@/assets/${imageFile}.png`),
        imageSize: [32, 32],
      };
    },
    matchElementToItem(element, item, hint) {
      if (element.id === item.id && element.is_factory === item.isFactory) {
        item.hint = hint;
        item.style = element.un_work
            ? this.setImageStyle(element, 'gray')
            : (element.color in {0: 'green', 1: 'yellow', 10: 'red', 20: 'blue'})
                ? this.setImageStyle(element, {0: 'green', 1: 'yellow', 10: 'red', 20: 'blue'}[element.color])
                : item.style;
      }
  },
    setIconAndHint(element) {
      let hint, extendName;
      if (element.is_factory === false) {
        extendName = `${element.name} (создан в ${element.created} г.)`;
        hint = element.un_work
            ? `<span>АПН на техническом обслуживании</span> <br>`
            : element.excess
                ? `<span>Превышения ПДКмр:</span> <br>${element.excess}`
                : `<span>Превышений ПДКмр: не зафиксировано</span>`;
      } else {
        extendName = element.name;
        hint = `<span>${element.name}</span><br>`;
      }

      this.points.push({
        coords: [element.latitude, element.longitude],
        id: element.id,
        name: element.name,
        extendName: extendName,
        address: element.address,
        temperature: element.temperature,
        windDirection: element.wind_direction,
        atPressure: element.at_pressure,
        airHumidity: element.air_humidity,
        windSpeed: element.wind_speed,
        isFactory: element.is_factory
      });

      this.points.forEach(item => this.matchElementToItem(element, item, hint));
    },
    getMapPlaces() {
      axios
        .get('/air/get-map-markers')
        .then(response => {
          response.data.forEach(this.setIconAndHint);

          this.firstLaunch = false;
        })
        .catch(err => {
          this.err = true
          console.log(err)
        });
    },
    startTimer() {
      this.intervalId = setInterval(async () => {
        if (!this.isWait) {
          await this.waitForFocus();
          this.getMapPlaces();
        }
      }, (this.getMillisecondsToNearestLabel()));
    },
    getMillisecondsToNearestLabel() {
      let date = new Date()
      let minutes = date.getMinutes();
      let hour = date.getHours();

      let nextMark;
      if (minutes < 5) {
        nextMark = 5;
      } else if (minutes < 25) {
        nextMark = 25;
      } else if (minutes < 45) {
        nextMark = 45;
      } else {
        nextMark = 5;
        hour++;
      }
      const nextMarkDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), hour, nextMark);
      return nextMarkDate - date;
    },
    waitForFocus() {
      return new Promise((resolve) => {
        const checkFocus = () => {
          if (document.hasFocus()) {
            this.isWait = false;
            resolve();
          } else {
            this.isWait = true;
            setTimeout(checkFocus, 1000);
          }
        };
        checkFocus();
      });
    },
  },
  created() {
    this.getMapPlaces();
    this.startTimer();

    bus.$on('show-map-legend', value => {
      this.showMapLegend = value
    })

    bus.$on('change-loading', () => {
      this.loading = false
    })

    bus.$on('update-usePointId', () => {
      this.usePointId = 0
    })
  }
}
</script>

<style>
.legend-container {
  margin-left: 5px;
  margin-bottom: 5px;
  box-shadow: 0 0 11px 1px #ccc;
  border: 1px solid lightgrey;
  bottom: 0;
  background-color: white;
  position: absolute;
  width: 400px;
  height: 310px;
}

.small-legend-container {
  margin-left: 5px;
  margin-bottom: 50px;
  box-shadow: 0 0 11px 1px #ccc;
  border: 1px solid lightgrey;
  bottom: 0;
  background-color: white;
  position: absolute;
  width: 140px;
  height: 30px;
}

.map-container {
  align-items: center;
  width: 100%;
  height: 100%;
  display: flex;
}

.alert-container{
  position: absolute;
  bottom: 50px;
  left: 45%;
}

.select-container{
  z-index: 1;
  position: absolute;
  background: white;
  top: 10px;
  left: 80px;
}
</style>